<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div class="recharge-root">
        <Top></Top>
        <div class="recharge-body___1UbSf ">
            <div class="side-menu-layout">
                <div class="content_menu">
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" style="padding-left: 16px;"
                                :class="active == 'assets_detail' ? 'ant-menu-item-selected' : ''"
                                @click="changeTab('/assets/index','assets_detail')">
                                <a>{{ $t('m.assets.nav[0]') }}</a>
                            </li>
                            <li class="ant-menu-item" style="padding-left: 16px;"
                                :class="active == 'recharge' ? 'ant-menu-item-selected' : ''"
                                @click="changeTab('/assets/recharge','recharge')">
                                <a>{{ $t('m.assets.nav[1]') }}</a>
                            </li>
                            <li class="ant-menu-item" style="padding-left: 16px;"
                                :class="active == 'withdraw' ? 'ant-menu-item-selected' : ''"
                                @click="changeTab('/assets/withdraw','withdraw')">
                                <a>{{ $t('m.assets.nav[2]') }}</a>
                            </li>
                            <li class="ant-menu-item" style="padding-left: 16px;"
                                :class="active == 'record' ? 'ant-menu-item-selected' : ''"
                                @click="changeTab('/assets/record','record')">
                                <a>{{ $t('m.assets.nav[3]') }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="menu___aQSZq">
                        <ul class="ant-menu kc-menu  ant-menu-light ant-menu-root ant-menu-inline">
                            <li class="ant-menu-item" style="padding-left: 16px;"
                                :class="active == 'account' ? 'ant-menu-item-selected' : ''"
                                @click="changeTab('/assets/account','account')">
                                <a>{{ $t('m.assets.nav[4]') }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="content_main">
                    <div class="bindSecurity___1eyXH" v-if="userInfo.dealpwd != 1">
                        <div class="ant-card ant-card-bordered ant-card-wider-padding" style="min-height: 480px;">
                            <div class="ant-card-body">
                                <h1 class="title___1qC8t">{{ $t('m.assets.nav[1]') }}</h1>
                                <div class="bindContent___snoJH">
                                    <div class="security___35DnW">
                                        <div class="content___1qIyq">
                                            <h1>{{ $t('m.assets.text[2]') }}</h1>
                                            <div class="alertContainer___1_aKH">
                                                <!--<div class="alertItem___3KOxN">-->
                                                <!--<div class="ant-alert ant-alert-error">-->
                                                <!--<img src="@/assets/img/cha.png" alt="">-->
                                                <!--<span class="ant-alert-message">开启手机验证保护</span>-->
                                                <!--</div>-->
                                                <!--<a>去设置</a>-->
                                                <!--</div>-->
                                                <div class="alertItem___3KOxN">
                                                    <div class="ant-alert ant-alert-error">
                                                        <img src="@/assets/img/cha.png" alt="">
                                                        <span class="ant-alert-message">{{ $t('m.assets.text[3]') }}</span>
                                                    </div>
                                                    <a @click="changeRoute('/deal_pwd')">{{ $t('m.assets.text[4]')
                                                        }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="StepTwo___tY6XZ">
                            <div class="ant-card topContainer___2ao99 ant-card-bordered ant-card-wider-padding ant-card-padding-transition">
                                <div class="ant-card-body">
                                    <div class="content___314Eg">
                                        <h1 class="title___1qC8t">{{ $t('m.assets.nav[1]') }}</h1>
                                        <div class="kc-select  ant-select ant-select-enabled" style="width: 100%;"
                                             @click="coin.show = !coin.show">
                                            <div class="ant-select-selection ant-select-selection--single">
                                                <div class="ant-select-selection__rendered" v-if="coin.name == ''">
                                                    <img src="@/assets/img/sousuo.png" alt="">
                                                    <div class="ant-select-selection__placeholder"
                                                         style="display: block; user-select: none;">{{
                                                        $t('m.assets.text[25]')
                                                        }}
                                                    </div>
                                                    <i></i>
                                                </div>
                                                <div class="coin-list-active" v-else>
                                                    <img :src="coin.image" alt="">
                                                    <span class="coin_name">{{ coin.name }}</span>
                                                    <span class="coin_full_name">{{ coin.full_name }}</span>
                                                    <i></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="coin_container" v-if="coin.show">
                                            <div class="coin_list" v-for="(v,k) in currencyAll" :key="k"
                                                 @click="changeCoin(v)">
                                                <img :src="requestConfig.host + v.currency_img" alt="">
                                                <span class="coin_name">{{ v.currency_name }}</span>
                                                <span>{{ v.currency_fullname }}</span>
                                            </div>
                                        </div>
                                        <div v-show="coin.name != ''">
                                            <div class="addressBox___3umVw">
                                                <div class="header___3ytYL">
                                                    <p>
                                                        <img :src="coin.image" alt="">
                                                        <span class="ml-6">{{ coin.name }}</span>
                                                        <span v-show="coin.name == 'USDT'">(ERC20)</span>
                                                        <span class="ml-6 mr-6">{{ coin.full_name }}</span>{{ $t('m.assets.text[26]') }}：
                                                    </p>
                                                </div>
                                                <div class="body___2CaiS">
                                                    <div class="addressItem___2ByO9">
                                                        <div class="address___2LkvT">
                                                            <p class="pt-10">{{ rechargeDetail.address }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="foot___37gi9">
                                                    <div class="footRight___nh1zM">
                                                        <img src="@/assets/img/copy.png" alt=""
                                                             v-clipboard:copy="address"
                                                             v-clipboard:success="doClipboard"
                                                             v-clipboard:error="">
                                                        <div class="code_img">
                                                            <img src="@/assets/img/code.png" alt="" class="qrcode">
                                                            <div class="code">
                                                                <canvas id="canvas666"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="explanBox___1oQ7i" style="text-align: left">
                                                <p class="explanTitle___2ZrPr">{{ $t('m.assets.text[27]') }}：</p>
                                                <div class="explanItem___cNupX">
                                                    <div class="left___3DPKS">
                                                        <img src="@/assets/img/li.png" alt="">
                                                    </div>
                                                    <div class="right___sPKZh">
                                                        <p>
                                                            {{ $t('m.assets.text[28]') }} <span class="color-danger">{{ coin.name }}</span>
                                                            {{ $t('m.assets.text[29]') }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="explanItem___cNupX">
                                                    <div class="left___3DPKS">
                                                        <img src="@/assets/img/li.png" alt="">
                                                    </div>
                                                    <div class="right___sPKZh">
                                                        <p style="text-align: left">
                                                            {{ $t('m.assets.text[30]') }}
                                                            <span class="color-danger">{{ coin.name }}</span> {{
                                                            $t('m.assets.text[31]') }}
                                                            <span class="color-danger">{{ coin.name }}</span>{{
                                                            $t('m.assets.text[32]') }}
                                                            <span class="color-danger">{{ coin.name }}</span>
                                                            {{ $t('m.assets.text[33]') }}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="explanItem___cNupX">
                                                    <div class="left___3DPKS">
                                                        <img src="@/assets/img/li.png" alt="">
                                                    </div>
                                                    <div class="right___sPKZh">
                                                        <p>{{ $t('m.assets.text[34]') }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="ant-card logsCard___sWB03 ant-card-bordered ant-card-wider-padding ant-card-padding-transition"
                                 v-show="coin.name != ''">
                                <div class="ant-card-head">
                                    <div class="ant-card-head-wrapper">
                                        <div class="ant-card-head-title">{{ $t('m.assets.text[5]') }}</div>
                                    </div>
                                </div>
                                <div class="ant-card-body" style="padding: 8px 20px 20px 24px;">
                                    <div class="tableContent___1_3Yq">
                                        <div class="ant-table-wrapper">
                                            <div class="ant-spin-nested-loading">
                                                <div class="ant-spin-container">
                                                    <div class="ant-table ant-table-default ant-table-empty ant-table-scroll-position-left">
                                                        <div class="ant-table-content">
                                                            <div class="ant-table-body">
                                                                <table>
                                                                    <thead class="ant-table-thead">
                                                                    <tr>
                                                                        <th><span>{{$t('m.assets.table[1]')}}</span>
                                                                        </th>
                                                                        <th><span>{{$t('m.assets.table[2]')}}</span>
                                                                        </th>
                                                                        <th><span>{{$t('m.assets.text[12]')}}</span>
                                                                        </th>
                                                                        <th><span>{{$t('m.assets.table[12]')}}</span>
                                                                        </th>
                                                                        <th><span>confirmations</span>
                                                                        </th>
                                                                    </tr>
                                                                    </thead>
                                                                    <tbody class="ant-table-tbody">
                                                                    <tr v-show="currencyInfo.currency_type == 3 &&
                                                                        v.from.toUpperCase() != address.toUpperCase()"
                                                                        v-for="v in erc20List">
                                                                        <td><span>{{ v.timeStamp | timeDate }}</span>
                                                                        </td>
                                                                        <td><span>{{ v.value / 10 ** 18 }}</span></td>
                                                                        <td><span>{{ addressSub(v.from) }}</span></td>
                                                                        <td><span>{{ addressSub(v.hash) }}</span></td>
                                                                        <td style="width: 110px">
                                                                            <span v-if="v.confirmations > 30"
                                                                                  style="color: #689E7D">Success</span>
                                                                            <span v-else style="color: #D9A862">{{v.confirmations}}/30 confirmation</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-for="v in erc20List"
                                                                        v-show="currencyInfo.currency_type == 2 &&
                                                                        v.to.toUpperCase() == address.toUpperCase() &&
                                                                        Number(v.value / 10 ** 18) > 0.01">
                                                                        <td><span>{{ v.timeStamp | timeDate }}</span>
                                                                        </td>
                                                                        <td><span>{{ v.value / 10 ** 18 }}</span></td>
                                                                        <td><span>{{ addressSub(v.from) }}</span></td>
                                                                        <td><span>{{ addressSub(v.hash) }}</span></td>
                                                                        <td style="width: 110px">
                                                                            <span v-if="v.confirmations > 30"
                                                                                  style="color: #689E7D">Success</span>
                                                                            <span v-else style="color: #D9A862">{{v.confirmations}}/30 confirmation</span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-for="v in btcList"
                                                                        v-show="currencyInfo.currency_type == 0">
                                                                        <td><span>{{ v.block_time | timeDate }}</span>
                                                                        </td>
                                                                        <td>
                                                                            <span>{{ v.outputs_value / 10 ** 18 }}</span>
                                                                        </td>
                                                                        <td><span>{{ addressSub(v.from) }}</span></td>
                                                                        <td><span>{{ addressSub(v.hash) }}</span></td>
                                                                        <td style="width: 110px">
                                                                            <span v-if="v.confirmations > 30"
                                                                                  style="color: #689E7D">Success</span>
                                                                            <span v-else style="color: #D9A862">{{v.confirmations}}/30 confirmation</span>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                            <div class="ant-table-placeholder">
                                                                <div style="padding-top: 100px;"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Bottom></Bottom>
    </div>
</template>

<script>
    import Top from '@/components/top'
    import Bottom from '@/components/bottom'
    import QRCode from 'qrcode';

    export default {
        name: "recharge",
        components: {
            Top, Bottom
        },
        created() {
            let cid = this.$route.query.cid;
            if (cid) {
                this.changeCoin(this.currencyAll[cid]);
            }
        },
        data() {
            return {
                active: 'recharge',
                coin: {
                    show: false,
                    name: '',
                    full_name: '',
                    image: ''
                },
                currencyInfo: {},
                rechargeDetail: {},
                address: "",
                rechargeList: [],
                erc20List: [],
                btcList: [],
                request: {
                    pageNo: 1,
                    pageSize: 10,
                    timeBegin: "",
                    timeEnd: "",
                    currency_id: ""
                }
            }
        },
        methods: {
            changeTab: function (url, path) {
                this.active = path;
                this.changeRoute(url);
            },
            changeCoin: function (v) {
                this.coin.show = false;
                this.coin.name = v.currency_name;
                this.coin.full_name = v.currency_fullname;
                this.coin.image = this.requestConfig.host + v.currency_img;
                this.getDetail(v.id);
            },
            getDetail (id) {
                this.rechargeDetail = {};
                this.$axios.post(this.requestConfig.host + "/index/Currency/currencyUserDetail", this.signature({
                    currency_id: id,
                    token: this.userInfo.key,
                    uid: this.userInfo.uid
                })).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.aLoadV({show: false});
                    this.rechargeDetail = res.info;
                    this.address = res.info.address;
                    this.showQrcode();
                    this.currencyInfo = this.currencyAll[this.rechargeDetail.currency_id];
                    this.getRecharge();
                    /*switch (this.currencyInfo.currency_type) {
                        case 0:
                            console.log("BTC");
                            this.getBtc();
                            break;
                        case 2:
                            this.getEther();
                            break;
                        case 3:
                            this.getErc20Recharge();
                            break;
                        default:
                            this.getRecharge();
                            break;
                    }*/
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    this.aLoadV({show: false});
                    this.aMyAlert({
                        show: true,
                        msg: e
                    })
                })
            },
            showQrcode: function () {
                let canvas = document.getElementById('canvas666');
                QRCode.toCanvas(canvas, this.address, {
                    width: 160,
                    margin: 10
                }, function (error) {
                    if (error) console.error(error);
                    console.log('success!');
                })
            },
            doClipboard: function () {
                this.$message.success(this.$t('m.assets.text[40]'));
            },
            getRecharge: function (id) {
                this.rechargeList = [];
                this.request.currency_id = id;
                let obj = JSON.parse(JSON.stringify(this.request));
                let paramData = this.signRequest(obj);
                paramData.signature = this.signature(paramData);
                this.$axios.get(this.requestConfig.host + "/index/Recharge/rechargeList", {
                    params:paramData,
                }).then((res) => {
                    return this.checkResponse(res);
                }).then((res) => {
                    this.aLoadV({show: false});
                    this.rechargeList = res.list;
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    this.aLoadV({show: false});
                    this.aMyAlert({
                        show: true,
                        msg: e
                    })
                })
            },
            /*getErc20Recharge: function () {
                this.aLoadV({show: true});
                this.$axios.get("http://api.etherscan.io/api", {
                    params: {
                        module: "account",
                        action: "tokentx",
                        address: this.address,
                        startblock: 0,
                        endblock: 999999999,
                        contractaddress: this.currencyInfo.contract_address
                    },
                }).then((res) => {
                    console.log(res);
                    this.erc20List = res.data.result;
                }).catch((e) => {
                    if (e == 20001) return;
                    console.log(e);
                    this.aLoadV({show: false});
                    this.aMyAlert({
                        show: true,
                        msg: e
                    })
                })
            },
            getEther: function () {
                this.aLoadV({show: true});
                this.$axios.get("http://api.etherscan.io/api", {
                    params: {
                        module: "account",
                        action: "txlist",
                        address: this.address,
                        startblock: 0,
                        endblock: 999999999,
                        // contractaddress: this.currencyInfo.contract_address
                    },
                }).then((res) => {
                    console.log(res);
                    this.erc20List = res.data.result;
                }).catch((e) => {
                    console.log(e);
                    this.aLoadV({show: false});
                    this.aMyAlert({
                        show: true,
                        msg: e
                    })
                })
            },
            getBtc: function () {
                this.aLoadV({show: true});
                this.$axios.get("https://chain.api.btc.com/v3/address/" + this.address + "/tx").then((res) => {
                    if (res.data.data != null) {
                        this.btcList = res.data.data.list;
                    }
                }).catch((e) => {
                    console.log(e);
                    this.aLoadV({show: false});
                    this.aMyAlert({
                        show: true,
                        msg: e
                    })
                })
            }*/
        }
    }
</script>

<style scoped>
    @import "../../assets/css/recharge.css";
</style>
